import { Component, Input, OnInit } from '@angular/core';

export interface RadialGradient {
  cx?: string;
  cy?: string;
  r?: string;
  fx?: string;
  fy?: string;
  colors: GradientColor[];
}

export interface GradientColor {
  stopColor: string;
  offset: number;
}

@Component({
  selector: 'def-sprites',
  templateUrl: './def-sprites.component.html',
  styleUrls: ['./def-sprites.component.scss'],
})
export class DefSpritesComponent implements OnInit {
  @Input() sprite = '';
  @Input() color: 'primary' | 'secondary' | 'default' | 'disabled' | 'enabled' | 'create' | 'dark' | 'grey' | 'red' | 'darkblue' | 'white' | 'black' | 'stroked';
  @Input() width: string;
  @Input() height: string;
  @Input() reverse: boolean;
  @Input() incline: boolean;
  @Input() gradient: RadialGradient = null;
  pathSprite: string;

  ngOnInit() {
    this.pathSprite = `./assets/sprites/sprite.svg#${this.sprite}`;
  }
}
